import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mibi-admin-activate-view',
    templateUrl: './admin-activate-view.component.html'
})
export class AdminActivateViewComponent {

}
